import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";
import SnapCameraView from "./components/SnapCameraView";
import "./SnapCameraTestPage.css";

const SNAP_API_TOKEN = process.env.REACT_APP_SNAP_API_TOKEN?.trim() ?? "";
const SNAP_TOKEN_PLACEHOLDER = "PUT_STAGING_SNAP_API_TOKEN_HERE";

export default function SnapCameraTestPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    console.log("[SNAP_PERF] page_mount");

    console.log("[SNAP_TOKEN_ENV]", {
      hasToken: Boolean(SNAP_API_TOKEN),
      tokenContainsProduction: SNAP_API_TOKEN.includes("PRODUCTION"),
      tokenContainsStaging: SNAP_API_TOKEN.includes("STAGING"),
    });

    if (!SNAP_API_TOKEN || SNAP_API_TOKEN === SNAP_TOKEN_PLACEHOLDER) return;
    console.log("[SNAP_CAMERA_INIT]", {
      hasToken: true,
      tokenLooksJwt: SNAP_API_TOKEN.startsWith("eyJ"),
      lensGroupId: "ef0710f5-81af-49c2-ada4-37ce1e739a7b",
    });
  }, []);

  if (!SNAP_API_TOKEN || SNAP_API_TOKEN === SNAP_TOKEN_PLACEHOLDER) {
    return (
      <div className="snap-camera-page snap-camera-page--config-missing">
        <header className="snap-camera-page__header">
          <button
            type="button"
            className="snap-camera-page__back"
            onClick={() => navigate(-1)}
            aria-label={t("back", { defaultValue: "Back" })}
          >
            <ArrowLeft size={22} aria-hidden />
          </button>
        </header>
        <div className="snap-camera-config-missing">
          <h1>
            {t("snap_camera.config_missing_title", {
              defaultValue: "Snap Camera Kit not configured",
            })}
          </h1>
          <p>
            {t("snap_camera.config_missing_body", {
              defaultValue:
                "Add REACT_APP_SNAP_API_TOKEN to your .env file, then restart the dev server.",
            })}
          </p>
          <p className="snap-camera-config-missing__hint">
            <code>REACT_APP_SNAP_API_TOKEN=your_token_here</code>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="snap-camera-page">
      <header className="snap-camera-page__header">
        <button
          type="button"
          className="snap-camera-page__back"
          onClick={() => navigate(-1)}
          aria-label={t("back", { defaultValue: "Back" })}
        >
          <ArrowLeft size={22} aria-hidden />
        </button>
      </header>

      <div className="snap-camera-page__shell">
        <SnapCameraView apiToken={SNAP_API_TOKEN} />
      </div>
    </div>
  );
}
